import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37c57a50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["required"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Pick one", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = ["type", "required", "readonly", "tabIndex", "step", "min", "max"]
const _hoisted_6 = ["type", "required", "readonly", "tabIndex", "step", "min", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createVNode(_component_localized_text, {
        localizedKey: _ctx.labelKey,
        text: _ctx.labelText,
        asterisks: _ctx.asterisks
      }, null, 8, ["localizedKey", "text", "asterisks"])
    ]),
    (_ctx.type == 'select')
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 0,
          class: "form-control",
          required: _ctx.required,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
        }, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: _ctx.itemValue ? item[_ctx.itemValue] : item
            }, _toDisplayString(_ctx.itemLabel ? item[_ctx.itemLabel] : item), 9, _hoisted_4))
          }), 128))
        ], 40, _hoisted_2)), [
          [_vModelSelect, _ctx.localValue]
        ])
      : (_ctx.type == 'textarea')
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 1,
            class: "form-control",
            type: _ctx.type,
            required: _ctx.required,
            readonly: _ctx.readonly,
            tabIndex: _ctx.tabIndex,
            step: _ctx.step,
            min: _ctx.min,
            max: _ctx.max,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue) = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
          }, "\r\n        ", 40, _hoisted_5)), [
            [_vModelText, _ctx.localValue]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            class: "form-control",
            type: _ctx.type,
            required: _ctx.required,
            readonly: _ctx.readonly,
            tabIndex: _ctx.tabIndex,
            step: _ctx.step,
            min: _ctx.min,
            max: _ctx.max,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue) = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
          }, null, 40, _hoisted_6)), [
            [_vModelDynamic, _ctx.localValue]
          ])
  ]))
}